import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import {
  licenseUrl,
} from './routes';

export function homePageBlurb() {
  return (
    <>
      EVE is a model for the prediction of clinical significance of human variants based on sequences of diverse organisms across evolution. It uses fully unsupervised deep learning trained on amino acid sequences of over 140K species. We make predictions for all single amino acid variants of disease related genes, which come in the form of a score that ranges from 1, most pathogenic, to 0, most benign.
      <br/><br/><br/>
      This project has been developed by:
      <br/><br/>
      Jonathan Frazer*, Pascal Notin*, Mafalda Dias*, Aidan Gomez, Joseph K. Min, Kelly Brock, Yarin Gal** and Debora Marks**
      <br/>
      * these authors contributed equally
      <br/>
      ** corresponding authors
      <br/><br/>
      <b>Marks Lab</b> - Harvard Medical School
      <br/>
      <b>OATML</b> - Oxford Applied and Theoretical Machine Learning Group
      <br/><br/><br/>
      You can read EVE’s publication <a href='https://www.nature.com/articles/s41586-021-04043-8' target='_blank' rel='noreferrer'>here</a>.
      <br/><br/>
      You can download the EVE scores, ClinVar data, gnomAD frequencies and more for all proteins modeled so far <Link exact='true' to='/download/bulk'>here</Link>.
      <br/>
      Alternatively you can explore the results for a particular protein by using the search bar above.
      <br/><br/>
      To create additional EVE models yourself or to simply browse through the code, check out our <a href='https://github.com/OATML-Markslab/EVE' target='_blank' rel='noreferrer'>repository on GitHub</a>!
    </>
  )
}

export function homePageSideBarBlurb() {
  return (
    <>
      <h3>
        <b>EVE</b>
        <br/>
        <b>E</b>volutionary model of <b>V</b>ariant <b>E</b>ffect
      </h3>
      <p>
        A model for the prediction of clinical significance of human variants based on sequences of diverse organisms across evolution
        <br/>
        <br/>
        Project developed by:
        <br/>
        Jonathan Frazer*, Pascal Notin*, Mafalda Dias*, Aidan Gomez, Kelly Brock,
        Yarin Gal** and Debora Marks**
        <br/>
        * these authors contributed equally
        <br/>
        ** corresponding authors
        <br/><br/>
        <b>Marks Lab</b> - Harvard Medical School
        <br/>
        <b>OATML</b> - Oxford Applied and Theoretical Machine Learning Group
      </p>
    </>
  )
}

export function homePageContactUsBlurb() {
  return (
    <>
      <p>
        We are adding predictions for new genes regularly—can’t find the gene/protein you are looking for?
        <br/>
        <a href='mailto:support@evemodel.org' target='_blank' rel='noreferrer'>Contact us</a> and we can run it for you!
      </p>
    </>
  )
}

export function heatMapBlurb() {
  return (
    <>
      Heatmap of EVE scores. Positions with no EVE score are shown in white.
    </>
  )
}

export function licenseBlurb() {
  return (
    <>
      The downloading of this data, and of all other data on this site, falls under the <a href='/LICENSE.txt' target='_blank'>MIT License</a>.
    </>
  )
}

export function proteinScatterAndViolinPlotsBlurb() {
  return (
    <>
      Scatter and violin plots of EVE scores for variants seen in humans to date (variants found in ClinVar, gnomAD or the UK Biobank).
      The dashed lines show EVE classification boundaries for the 75% most confident class assignments (over all possible amino acid variants), which on average corresponds to ~90% classification accuracy.
      Only ClinVar labels with one star quality rating or higher were considered.
    </>
  )
}

export function proteinSummaryStatsBlurb() {
  return (
    <>
      <h5 style={{display: 'inline'}}>Performance Statistics.</h5>
      <p style={{display: 'inline'}}> Only ClinVar labels with one star quality rating or higher were considered.</p>
      <p style={{display: 'inline'}}> The 75% set corresponds to the 75% most confident class assignments (over all possible amino acid variants).</p>
      <br/>
      <br/>
      <b style={{color: 'red'}}>WARNING:</b> If the number of  ClinVar labels is small, these statistics are of limited value.
      Aggregate performance statistics over all labels of all genes can be found <a href='https://static-content.springer.com/esm/art%3A10.1038%2Fs41586-021-04043-8/MediaObjects/41586_2021_4043_MOESM5_ESM.xlsx' target='_blank' rel='noreferrer'>here</a>.
    </>
  )
}

export function proteinPositionsVariantsTableBlurb() {
  return (
    <>
      <b>Reference aa:</b> Amino acid in reference sequence.<br/>
      <b>Position:</b> Position in amino acid sequence.<br/>
      <b>Variant aa:</b> Amino acid variant.<br/>
      <b>EVE Score:</b> EVE pathogenicity score.<br/>
      <b>EVE Class (75% Set):</b> EVE classification when only classifying the 75% most confident of all possible amino acid substitutions.<br/>
      <b>Class Uncertainty:</b> EVE classification uncertainty.<br/>
      <b>Frequency (gnomAD v2):</b> Frequency in gnomAD v2.<br/>
      <b>ClinVar Label:</b> Label found in ClinVar.<br/>
    </>
  )
}
